export const flightStatusTexts = {
  not_stated: { status: 'На рассмотрении', class: 'warning' },
  accepted: { status: 'Утверждено', class: 'accept' },
  declined: { status: 'Отказано', class: 'decline' },
}
